<template>
  <div class="menu-container">
    <div class="logo-text">
      <img class="logo" src="@/assets/images/menu/menu-logo.png" alt="" srcset="" />
      <span class="text">牛姆管理后台</span>
    </div>
    <el-menu :default-active="route.path" class="side-menu">
      <template v-for="item in menuRoutes">
        <!-- 侧边弹二级菜单展示形式 -->
        <el-menu
          v-if="item.children"
          :collapse="true"
          :default-active="route.path"
          :popper-offset="2"
          router
        >
          <el-sub-menu popper-class="side-sub-menu" :index="item.path" :teleported="false">
            <!-- 一级 -->
            <template #title>
              <div class="icon-text">
                <Icon
                  class="icon"
                  :name="getSubIconName(item.meta.icon, item.children)"
                  size="22px"
                />
                {{ item.meta.title }}
              </div>
            </template>
            <!-- 二级 -->
            <div class="item-group">牛牛护驾</div>
            <router-link v-for="child in item.children" :key="child.path" :to="child.path">
              <el-menu-item :index="child.path">
                <div class="icon-text">
                  {{ child.meta.title }}
                </div>
              </el-menu-item>
            </router-link>
          </el-sub-menu>
        </el-menu>
        <router-link v-else :to="item.path">
          <el-menu-item :index="item.path">
            <div class="icon-text">
              <Icon
                class="icon"
                :name="`${item.meta.icon}${route.path === item.path ? '-fill' : ''}`"
                size="22px"
              />
              {{ item.meta.title }}
            </div>
          </el-menu-item>
        </router-link>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import Icon from '@/components/Icons.vue'
import { constantRoutes } from '@/router/index'

const router = useRouter()
const route = useRoute()

const filterMenuRoutes = (routes = []) => {
  return routes
    .filter((route) => route?.show !== false)
    .map((route) => {
      const nextRoute = { ...route }

      if (Array.isArray(route.children)) {
        nextRoute.children = filterMenuRoutes(route.children)
      }

      return nextRoute
    })
    .filter((route) => !Array.isArray(route.children) || route.children.length > 0)
}

const menuRoutes = computed(() => {
  const rootRoute = constantRoutes.find((item) => item.path === '')
  return filterMenuRoutes(rootRoute?.children || [])
})

const getSubIconName = (icon, children) => {
  const isFill = children.some((item) => item.path === route.path)
  return `${icon}${isFill ? '-fill' : ''}`
}
</script>

<style lang="scss" scoped>
.menu-container {
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 6px 58px #c4cbd6;
  width: 200px;
  padding-bottom: 10px;
  flex-shrink: 0;
  .logo-text {
    padding: 0 17px;
    display: flex;
    align-items: center;
    margin-top: 34px;
    margin-bottom: 18px;
    .logo {
      width: 31px;
      height: 32px;
    }
    .text {
      margin-left: 12px;
      font-size: 20px;
      font-weight: bold;
      color: #000000;
    }
  }

  .el-menu {
    // border: none;
    // // height: 100%;
    // min-width: 200px;
    // // padding: 10px 0;
    width: 100%;

    .icon {
      margin-right: 16px;
    }

    .el-menu-item,
    :deep(.el-sub-menu__title) {
      padding: 0 20px;
      font-size: 16px;
      color: #718096;
      line-height: inherit;
      height: auto;
      margin-bottom: 4px;
      &:hover {
        background-color: #fff !important;
        color: #3f8cff;
      }

      &.is-active {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 4px;
          height: 100%;
          border-radius: 2px;
          background: #3f8cff;
        }
        .icon-text {
          // background-color: #edf5fb !important;
          color: #3f8cff;
          border-radius: 8px;
          background: rgba(63, 140, 255, 0.1);
        }
      }
    }
  }

  .icon-text {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 12px;
    font-size: 14px;
    color: #718096;
  }
}

.side-menu {
  .el-sub-menu {
    &.is-active {
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 4px;
        height: 100%;
        border-radius: 2px;
        background: #3f8cff;
      }
      .icon-text {
        // background-color: #edf5fb !important;
        color: #3f8cff;
        border-radius: 8px;
        background: rgba(63, 140, 255, 0.1);
      }
    }
  }
  // 侧边弹的二级菜单样式
  :deep(.side-sub-menu) {
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 2px 6px rgba(42, 130, 228, 0.14);
    .el-menu {
      box-shadow: none;
      background: transparent;

      .item-group {
        height: 36px;
        font-size: 12px;
        color: #9c9c9c;
        line-height: 36px;
        border-bottom: 1px solid #eeeff2;
        padding: 0 12px;
      }

      a:focus-visible {
        outline: unset;
      }

      .el-menu-item {
        padding: 0 6px;
        margin-top: 4px;
        .icon-text {
          background-color: transparent;
          color: #718096;
          padding: 10px 8px;
          &:hover {
            background-color: #fff;
            color: #3f8cff;
          }
        }

        &.is-active {
          &::after {
            content: none;
          }
          .icon-text {
            // background-color: #edf5fb !important;
            color: #3f8cff;
            border-radius: 8px;
            background: rgba(63, 140, 255, 0.1);
          }
        }
      }
    }
  }
}
</style>
